import { apiBeAuth } from "@/entities/auth";

// 데이터 새로고침
export const GetDcaRefresh = async () => {
  const responseBody = await apiBeAuth<BaseResponse>("/user/dca/refresh", {
    method: "GET",
  });

  return responseBody;
};
